import React, { useEffect } from 'react';
import SemiconductorsBanner from './SemiconductorsBanner';
import Automotivemobilitecards from './Automotivemobilitecards';
import AutomobilityTabs from './AutomobilityTabs';
import Automobilityverticaltabs from './Automobilityverticaltabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import AerospaceanimatedCards from './AerospaceanimatedCards';
import AerospaceInsightsCards from './AerospaceInsightsCards';
import Industrypatners from './Industrypatners';
import Semiconductorsanimated from './Semiconductorsanimated';
import Semiverticaltabs from './Semiverticaltabs';

const SemiconductorsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
          // Scroll to the top of the page when the component mounts
 
  return (
    <div style={{background:'#fff'}}>
        <SemiconductorsBanner />
          {/* <MinningBanner /> */}
          {/* <RailtransportaionBanner /> */}
         <Automotivemobilitecards />
           <AutomobilityTabs />
           <Semiverticaltabs />
           {/* <Automobilityverticaltabs /> */}
           {/* <AerospaceIntroductioncards /> */}
           <Semiconductorsanimated />
           {/* <AerospaceanimatedCards /> */}
           <AerospaceInsightsCards />
           <Industrypatners />


        <style>
          {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
        </style>
    </div>
  )
}

export default SemiconductorsPage;